// src/components/common/FormNotification.js
// Komponen & hook notifikasi banner inline yang dipakai bersama oleh semua form.
// Tujuan: menampilkan notifikasi sukses/gagal yang konsisten saat submit data.
import { useState, useCallback } from "react";
import { Alert } from "react-bootstrap";

/**
 * Banner notifikasi inline (ditempatkan di dalam form/modal, di atas tombol).
 * @param {{type?: string, message?: string}|null} notif - isi notifikasi
 * @param {() => void} [onClose] - bila ada, banner bisa ditutup manual
 */
const FormNotification = ({ notif, onClose }) => {
  if (!notif || !notif.message) return null;
  return (
    <Alert
      variant={notif.type || "info"}
      onClose={onClose}
      dismissible={!!onClose}
      className="mb-3"
    >
      {notif.message}
    </Alert>
  );
};

/**
 * Hook kecil untuk mengelola state notifikasi form.
 * Contoh: const { notif, notifySuccess, notifyError, clearNotif } = useFormNotification();
 */
export const useFormNotification = () => {
  const [notif, setNotif] = useState(null);

  const notifySuccess = useCallback(
    (message) => setNotif({ type: "success", message }),
    []
  );
  const notifyError = useCallback(
    (message) => setNotif({ type: "danger", message }),
    []
  );
  const notify = useCallback(
    (type, message) => setNotif({ type, message }),
    []
  );
  const clearNotif = useCallback(() => setNotif(null), []);

  return { notif, setNotif, notify, notifySuccess, notifyError, clearNotif };
};

export default FormNotification;
